import { useAvaturnHelperType } from '@features/avaturn/pages/Avaturn/interfaces';
import { env } from 'env';

const { REACT_APP_CLIENT_ENV } = env;

export const getUseAvaturnHelper = () => {
  let useAvaturnHelper: useAvaturnHelperType;

  switch (REACT_APP_CLIENT_ENV) {
    case 'EK':
      useAvaturnHelper =
        require('@clients/ek/features/avaturn/hooks/useAvaturnHelper').default;
      break;
    default:
      useAvaturnHelper =
        require('@features/avaturn/hooks/useAvaturnHelper').default;
  }

  return useAvaturnHelper;
};
